import React, { useCallback, useContext, useState } from 'react';
import { BasicData } from '@App';
import { Tabs, Tab } from '@components/form/tabs';
import { useSelector } from 'react-redux';
import { Trans } from '@lingui/macro';
import OverviewTimeline from './overview-timeline';

const TripOverview = () => {
    const defaulFilters = useCallback(() => ["OvernightTravel", "OwnArrangement", "Carhire", "Mobile", "Stop", "CheckIn", "Stay", "CheckOut", "Route", "RouteStart", "RouteEnd", "StopArrival", "StopDeparture", "TravelArrangement"], []);
    const accommodationFilters = useCallback(() => ["OvernightTravel", "OwnArrangement", "Mobile", "Stop", "CheckIn", "Stay", "CheckOut", "StopArrival", "StopDeparture"], []);
    const transportFilters = useCallback(() => ["Carhire", "Route", "RouteStart", "RouteEnd", "TravelArrangement"], []);

    const [filters, setFilters] = useState(defaulFilters)
    const bodyData = useSelector((state) => state.bodyData.data);
    const { trip_summary } = useContext(BasicData);

    const onTabClick = useCallback((index) => {
        if (index === 0) {
            setFilters(defaulFilters)
        }

        if (index === 1) {
            setFilters(accommodationFilters)
        }

        if (index === 2) {
            setFilters(transportFilters)
        }
    }, [defaulFilters, accommodationFilters, transportFilters])

    return (
        <>
            {bodyData &&
                <div id="trip-overview">
                    <div>
                        <div className='trip-overview-timeline bg-white'>
                            <h2 className="text-md-center mb-[1.875rem]"><Trans>Trip Overview</Trans></h2>

                            <Tabs onTabClick={onTabClick}>
                                <Tab title="Full overview">
                                    <OverviewTimeline bodyData={bodyData} filters={filters} />
                                </Tab>
                                <Tab title="Accommodation">
                                    <OverviewTimeline bodyData={bodyData} filters={filters} />
                                </Tab>
                                <Tab title="Transport">
                                    <OverviewTimeline bodyData={bodyData} filters={filters} />
                                </Tab>
                            </Tabs>

                            {trip_summary?.basis_keys && <h5 className="key"><Trans>Key</Trans></h5>}
                            {trip_summary?.basis_keys?.map((basisKey, i) => (
                                <p className="key" key={i} dangerouslySetInnerHTML={{ __html: basisKey }} />
                            ))}
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default TripOverview;
